import type { BrandSpecial } from '@iheartjane/data-access';
import { useMemo } from 'react';

import { useJaneUser } from '@jane/shared/data-access';
import { brandSpecialOrProductHasSegments } from '@jane/shared/util';

export const useNeedsSignInForEligibility = ({
  brandSpecial,
  cartProduct,
}: {
  brandSpecial?: Pick<
    BrandSpecial,
    'exclude_user_segments' | 'include_user_segments'
  >;
  /** The one field read — structural so v1 and v3 cart products both fit. */
  cartProduct?: { brand_special_has_segment_rules?: boolean | null };
}) => {
  const { data: janeUser } = useJaneUser();

  const needsSignInForEligibility = useMemo(() => {
    if (janeUser?.user.authenticated) {
      return false;
    }

    return brandSpecialOrProductHasSegments({
      brandSpecial,
      cartProduct,
    });
  }, [janeUser?.user.authenticated, brandSpecial]);

  return needsSignInForEligibility;
};
